import React from 'react'
import { usePage } from '@inertiajs/react'
import { useToast } from '@/hooks/useToast'

// Bridges Rails flash (notice/alert) into the toast system. Shared by both layouts
// (OperatorLayout + PortfolioLayout) so the two headers can never drift on flash handling.
// Must be rendered inside a <ToastProvider>.
export default function FlashHandler() {
  const { props } = usePage<{ flash?: { notice?: string; alert?: string } }>()
  const { addToast } = useToast()
  const lastFlashRef = React.useRef<string | null>(null)

  React.useEffect(() => {
    if (props.flash?.notice && props.flash.notice !== lastFlashRef.current) {
      lastFlashRef.current = props.flash.notice
      addToast({ title: props.flash.notice })
    }
    if (props.flash?.alert && props.flash.alert !== lastFlashRef.current) {
      lastFlashRef.current = props.flash.alert
      addToast({ title: props.flash.alert, variant: 'destructive' })
    }
  }, [props.flash])

  return null
}
